import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Button, Input, Select, Textarea } from "../Form";
import { BiChevronDown } from "react-icons/bi";
import { sortsDatas } from "../Datas";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { toast } from "react-hot-toast";
import medicineService from "../../api/medicineService";

function AddEditMedicineModal({ closeModal, isOpen, datas, onRefresh }) {
  const [measures, setMeasures] = useState(sortsDatas.measure[0]);
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [stock, setStock] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (datas?.name) {
      setName(datas.name);
      setPrice(datas.price);
      setStock(datas.stock || datas.inStock); // Handle both keys
      setDescription(datas.description);
      const foundMeasure = sortsDatas.measure.find(m => m.name === datas.measure);
      setMeasures(foundMeasure || { name: datas.measure });
    } else {
      // Reset form for new entry
      setName("");
      setPrice("");
      setStock("");
      setDescription("");
      setMeasures(sortsDatas.measure[0]);
    }
  }, [datas, isOpen]);

  const submitHandler = async () => {
    try {
      if (!name || !price || !stock) {
        return toast.error("Please fill all required fields");
      }
      setLoading(true);
      const payload = {
        name,
        price: Number(price),
        inStock: Number(stock), // Backend expects inStock
        measure: measures.name,
        description,
      };

      if (datas?._id || datas?.id) {
        // Update
        const id = datas._id || datas.id;
        await medicineService.updateMedicine(id, payload);
        toast.success("Medicine updated successfully");
      } else {
        // Create
        await medicineService.createMedicine(payload);
        toast.success("Medicine created successfully");
      }

      onRefresh(); // Refresh parent list
      closeModal();
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      title={datas?.name ? "Edit Medicine" : "New Medicine"}
      width={"max-w-3xl"}
    >
      <div className='flex-colo gap-6'>
        <div className='grid w-full gap-4 sm:grid-cols-2'>
          <Input
            label='Medicine Name'
            color={true}
            placeholder='Ex: Paracetamol'
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <div className='flex w-full flex-col gap-3'>
            <p className='text-sm text-black'>Measure</p>
            <Select
              selectedPerson={measures}
              setSelectedPerson={setMeasures}
              datas={sortsDatas.measure}
            >
              <div className='flex-btn w-full rounded-lg border border-border p-4 text-sm font-light text-textGray focus:border focus:border-subMain'>
                {measures?.name} <BiChevronDown className='text-xl' />
              </div>
            </Select>
          </div>
        </div>

        <div className='grid w-full gap-4 sm:grid-cols-2'>
          <Input
            label='Price (Tsh)'
            type='number'
            color={true}
            placeholder='Ex: 2000'
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
          <Input
            label='Instock'
            type='number'
            color={true}
            placeholder='Ex: 100'
            value={stock}
            onChange={(e) => setStock(e.target.value)}
          />
        </div>

        {/* des */}
        <Textarea
          label='Description'
          placeholder='Write description here...'
          color={true}
          rows={5}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        {/* buttones */}
        <div className='grid w-full gap-4 sm:grid-cols-2'>
          <button
            onClick={closeModal}
            className='rounded-lg bg-red-600 bg-opacity-5 p-4 text-sm font-light text-red-600'
          >
            {datas?.name ? "Discard" : "Cancel"}
          </button>
          <Button
            label={loading ? "Saving..." : "Save"}
            Icon={HiOutlineCheckCircle}
            onClick={submitHandler}
            disabled={loading}
          />
        </div>
      </div>
    </Modal>
  );
}

export default AddEditMedicineModal;
